import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=3fb07544&"
import script from "./Spinner.vue?vue&type=script&lang=ts&"
export * from "./Spinner.vue?vue&type=script&lang=ts&"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=3fb07544&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports